module.exports = __webpack_public_path__ + "static/media/img05.710a0552.svg";